module.exports = __webpack_public_path__ + "static/img/Lz_mzjg_icon.png";